export const theme = {
  colors: {
    black: '#000000',

    primaryRed: '#BA0C2F',
    darkRed: '#8C122A',
    mediumRed: '#C61A37',
    lightRed: '#D91B3D',
    red: '#B92232',

    primaryBlack: '#222222',
    darkBlack: '#1A1817',
    mediumBlack: '#2C2C33',
    lightBlack: '#434343',

    primaryGold: '#B38D42',
    mediumGold: '#D7B370',
    lightGold: '#E3BD74',

    primaryOrange: '#FF8A22',

    darkGray: '#656565',

    white: '#FFFFFF',

    cloudPurple: '#14072B',
    limeGreen: '#AFFC41',
    neonPurple: '#7F41F6',
  },
}

export const AVAILABLE_BRANDS = {
  CLOUD_LIGHT: 'Cloud District - Light',
  CLOUD_DARK: 'Cloud District - Dark',
}
